import "./PlantsPage.css";

import DetailsPlant from "../../components/DetailsPlant/DetailsPlant";

function PlantsPage() {
  return (
    <div>
      <DetailsPlant />
    </div>
  );
}

export default PlantsPage;
